import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';
import SearchFilters from './components/SearchFilters';
import LogTable from './components/LogTable';
import { mockLogs, logTypeOptions, moduleOptions, operationTypeOptions } from './mockData';

export default function SystemLogsPage() {
  const [filteredLogs, setFilteredLogs] = useState(mockLogs);

  const handleSearch = (filters: any) => {
    let result = [...mockLogs];

    if (filters.operatorQuery) {
      result = result.filter(
        (log) =>
          log.operatorId.includes(filters.operatorQuery) ||
          log.operatorName.includes(filters.operatorQuery)
      );
    }

    if (filters.ip) {
      result = result.filter((log) => log.ip === filters.ip);
    }

    if (filters.logTypes.length > 0) {
      result = result.filter((log) => filters.logTypes.includes(log.logType));
    }

    if (filters.modules.length > 0) {
      result = result.filter((log) => filters.modules.includes(log.module));
    }

    if (filters.operationTypes.length > 0) {
      result = result.filter((log) =>
        log.operationType ? filters.operationTypes.includes(log.operationType) : false
      );
    }

    setFilteredLogs(result);
  };

  return (
    <MainLayout>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-900">操作日志</h1>
          <p className="text-sm text-gray-500 mt-1">查看和管理系统操作日志记录</p>
        </div>

        <SearchFilters
          onSearch={handleSearch}
          logTypeOptions={logTypeOptions}
          moduleOptions={moduleOptions}
          operationTypeOptions={operationTypeOptions}
        />

        <div className="mb-4 flex items-center justify-between">
          <div className="text-sm text-gray-600">
            共 <span className="font-semibold text-gray-900">{filteredLogs.length}</span> 条记录
          </div>
        </div>

        <LogTable logs={filteredLogs} />
      </div>
    </MainLayout>
  );
}
